import { usePutMutation } from "@/api/swr/useMutation";
import { changePasswordSchema } from "@/schema/app/profile/CompanyUser";
import { z } from "zod";

type Config = Parameters<
  typeof usePutMutation<typeof changePasswordSchema, z.ZodNull>
>[3];

export const useChangePassword = (config?: Config) => {
  return usePutMutation(
    changePasswordSchema,
    z.null(),
    "/app/company_users/profile/reset_password",
    config,
  );
};
